import { useNavigate } from "react-router-dom";

function CircularMenuItem({ 
    page, 
    bg,
    color, 
    image,
    link,
    rotation, 
    menuIsOpen, 
    transitionDelay,
    style
}) {
const navigate = useNavigate()
const goTo = ()=>{ navigate(link)}
    return (
        <div
            className={style.menuItem}
            style={{
              backgroundColor: bg,
              transform: `rotate(${rotation}deg) translate(${menuIsOpen ? 130 : 0}%) scale(0.9)`,
              transitionDelay: `${menuIsOpen ? transitionDelay : 0}ms`
            }}
        >
            <span title={page} style={{
                color: color,
                transform: `rotate(${-rotation}deg)`
            }}
            onClick = {goTo}
            >{image?<img src={image} alt="" width={"100%"}/>:page}</span>
        </div>
    );
}

export default CircularMenuItem;